import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sizeNormal",
  "use": "sizeNormal-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"sizeNormal\"><path d=\"M1 10h7v7H1v-7zm3.763 2H1v5h5v-3.763L2.497 16.74 1.26 15.503 4.763 12zM17 8h-7V1h7v7zm-3.586-2H17V1h-5v3.586l3.414-3.414 1.414 1.414L13.414 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol